/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type EobOutcome = 'paid' | 'partial' | 'denied';

export interface EobLineItem {
  code: string;
  description: string;
  billed: number;
  allowed: number;
  paid: number;
  adjustment: number;
  patientResp: number;
}

export interface EobRow {
  id: string;
  claimId: string;
  clientName: string;
  payer: string;
  adjudicatedAt: string;
  outcome: EobOutcome;
  lineItems: EobLineItem[];
  carcCodes: string[];
  rarcCodes: string[];
  eraId?: string;
  denialId?: string;
}

export const MOCK_EOBS: EobRow[] = [];

export function findEobById(id: string | undefined): EobRow | undefined {
  if (!id) return undefined;
  return MOCK_EOBS.find((r) => r.id === id);
}

export function eobTotals(eob: EobRow): {
  billed: number;
  allowed: number;
  paid: number;
  adjustment: number;
  patientResp: number;
} {
  return eob.lineItems.reduce(
    (acc, line) => ({
      billed: acc.billed + line.billed,
      allowed: acc.allowed + line.allowed,
      paid: acc.paid + line.paid,
      adjustment: acc.adjustment + line.adjustment,
      patientResp: acc.patientResp + line.patientResp,
    }),
    { billed: 0, allowed: 0, paid: 0, adjustment: 0, patientResp: 0 },
  );
}
